module.exports = __webpack_public_path__ + "static/img/4.d708ffd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/eng/4.png
// module id = IZVX
// module chunks = 0